import { atom } from "recoil"
import { Localization } from "@/types/localization.types"

export const localizationAtom = atom({
  key: "localization",
  default: {
    locale: "sg",
  } as Localization,
})
